module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register_msg_yz"
  }, [_c('h4', {
    staticClass: "color_5babf4 login_title"
  }, [_vm._v("注册新账号")]), _vm._v(" "), _c('p', {
    staticClass: "tip_sub_text"
  }, [_c('span', [_vm._v("短信验证码已发送至：")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "cshMobile"
    }
  }, [_vm._v(_vm._s(_vm.csmobile))])]), _vm._v(" "), _c('div', {
    staticClass: "forget_yzm login_mbtm6"
  }, [_c('label', {
    staticClass: "label_focus",
    attrs: {
      "for": "register_yzm"
    }
  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.setMess),
      expression: "user.setMess"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.user.setMess)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "setMess", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.memo),
      expression: "user.memo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control inline-block input_focus login_form",
    attrs: {
      "type": "text",
      "id": "register_yzm"
    },
    domProps: {
      "value": (_vm.user.memo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.reg()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "memo", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn_send text-center",
    attrs: {
      "href": "javascript:void(0);",
      "id": "notify"
    },
    on: {
      "click": function($event) {
        return _vm.notify()
      }
    }
  }, [_vm._v("重新发送")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "login_btn_box",
    attrs: {
      "id": "yz_reg"
    }
  }, [_c('a', {
    staticClass: "btn btn_h btn_issue margin_r_7",
    attrs: {
      "href": "javascript:void(0);",
      "id": "cloudRegisterNg"
    },
    on: {
      "click": function($event) {
        return _vm.reg()
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('small', {
    staticClass: "tip_sub_text",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v("没有收到验证码?")]), _vm._v("\n\t\t|\n\t\t"), _c('router-link', {
    staticClass: "color_308de2",
    attrs: {
      "to": "/login",
      "id": "register_btn"
    }
  }, [_c('small', [_vm._v("返回登录")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center login_title color_c"
  }, [(_vm.show) ? _c('div', {}, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label_focus",
    staticStyle: {
      "display": "none",
      "color": "#ccc"
    },
    attrs: {
      "id": "col"
    }
  }, [_c('label', {
    attrs: {
      "id": "sendTimes"
    }
  }, [_vm._v("倒计时60")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip_box kfzryz-hide"
  }, [_c('small', {
    staticClass: "tip_yz yzcontent"
  }, [_vm._v("验证码错误！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("当您无法收到校验码短信市，请逐一排查以下原因：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("*手机话费余额不足或其他手机原因；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("*短信收件箱已满；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("*被手机安全软件误判而拦截；")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4da7b54d"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/register_yz.vue
// module id = 1256
// module chunks = 1